import React from 'react';
import { LinkSize, LinkTarget } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';

import { AssociatedContent } from 'src/graphql/queries/GetContentHub';

import { ContentBlockItem } from './ContentBlockItem';

export interface ContentBlockItemListProps {
  associatedContent: AssociatedContent;
  fullWidthFirstContentEntry: boolean;
  onLearnMoreLinkClick: (cardTitle: string, link?: string, target?: LinkTarget) => void;
}

export const ContentBlockItemList: React.FC<ContentBlockItemListProps> = ({
  associatedContent,
  fullWidthFirstContentEntry,
  onLearnMoreLinkClick,
}) => {
  if (fullWidthFirstContentEntry) {
    const [firstContentBlock, ...restContentBlocks] = associatedContent;

    return (
      <div css={outerContainerStyles}>
        <div css={firstContentBlockContainerStyles}>
          <ContentBlockItem
            key={firstContentBlock.sys.id}
            content={firstContentBlock}
            onLearnMoreLinkClick={onLearnMoreLinkClick}
            linkSize={LinkSize.LARGE}
          />
        </div>
        <div css={associatedContentContainerStyles}>
          {restContentBlocks?.length > 0 &&
            restContentBlocks.map((content) => (
              <ContentBlockItem key={content.sys.id} content={content} onLearnMoreLinkClick={onLearnMoreLinkClick} />
            ))}
        </div>
      </div>
    );
  }

  return (
    <div css={associatedContentContainerStyles}>
      {associatedContent?.length > 0 &&
        associatedContent.map((content) => (
          <ContentBlockItem key={content.sys.id} content={content} onLearnMoreLinkClick={onLearnMoreLinkClick} />
        ))}
    </div>
  );
};

const outerContainerStyles = css({
  width: '100%',
  rowGap: token('space.200'),
  flexDirection: 'column',
  display: 'flex',
});

const firstContentBlockContainerStyles = css({
  padding: `0 ${token('space.100')}`,
});

const associatedContentContainerStyles = css({
  width: '100%',
  maxWidth: '1022px',
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  columnGap: token('space.300'),
  padding: `0 ${token('space.100')}`,

  [media.below.md]: {
    gridTemplateColumns: '1fr',
    rowGap: token('space.100'),
  },
});
